export default "__VITE_ASSET__CS5oVX5k__"